import User from "@/lib/user"

export default {
  methods: {
    getUserId: function() {
      return User.getUserId()
    },
    isMember: function() {
      return User.isMember()
    },
    isManager: function() {
      return User.isManager()
    },
    isPresident: function() {
      return User.isPresident()
    }
  }
}
